import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import logoFooter from "../../Assets/Images/logofooter_new.png"
import facebook from '../../Assets/Images/fb_icon.png'
import twitter from '../../Assets/Images/twitter_x_icon.png'
import instagram from '../../Assets/Images/ig_icon.png'
import linkedin from '../../Assets/Images/linkedin_icon.png'
import { Link } from 'react-router-dom';
import './Footer.css'; 

function Footer() {
  return (
    <footer >
      <Container >
        <Row >
          <Col lg={3} sm={12} md={12} >
            <div className="footer-thumb footer-info">
              <Image className='logo-image' src={logoFooter} alt="Logo"  />
            </div>
          </Col>

          <Col lg={4} md={4} sm={12} gap={5} >
            <div className="footer-thumb">
              <h2 className="menu-name footer-title">Contact Us</h2>
              <p className="footer-content">73-E, GD Arcade, A.K. Fazl-ul-Haq Rd, Blue Area, Islamabad</p>
              <p className="footer-content">cs@nayatel.com</p>
              <div className="phone-contact">
                <p className="footer-content">1441:<span className="footer-content"> +92 (51) 111 11 44 44</span></p>
              </div>
            </div>
          </Col>

          <Col lg={3} md={4} sm={12} className='menu-end' >
            <div className="footer-thumb">
              <h2 className="menu-name footer-title">Our Company</h2>
              <ul className="footer-link d-flex flex-column gap-1 " style={{marginTop:"-1rem"}}>
                <li><Link className="footer-content" to="https://nayatel.com/about">About Us</Link></li>
                <li><Link className="footer-content" to="/PrivacyPolicy">Privacy Policy</Link></li>
                <li><Link className="footer-content" to="/TermsCondition">Terms And Conditions</Link></li>

              </ul>
            </div>
          </Col>

          <Col lg={2} md={4} sm={12} className='menu-end'>
            <div className="footer-thumb">
              <h2 className="menu-name footer-title">Follow us</h2>
              <div className="social-icons" style={{marginTop:'-0.6rem'}}>
                <ul className="social-icon list-unstyled d-flex gap-2">
                  <li className="footerlist-icon ">
                    <a href="https://www.facebook.com/Nayatel">
                      <Image src={facebook} alt="Facebook" width="22" height="22" />
                    </a>
                  </li>
                  <li className="footerlist-icon">
                    <a href="https://twitter.com/nayatelpk?lang=en">
                      <Image src={twitter} alt="Twitter" width="22" height="22" />
                    </a>
                  </li>
                  <li className="footerlist-icon">
                    <a href="https://www.instagram.com/nayatel_official/?hl=en">
                      <Image src={instagram} width="22" height="22" />
                    </a>
                  </li>
                  <li className="footerlist-icon">
                    <a href="https://www.linkedin.com/company/nayatel/">
                      <Image src={linkedin} alt="LinkedIn" width="22" height="22" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
